import { createApi } from "@reduxjs/toolkit/query/react";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";


export interface AccountSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
  company_id: string;
  filter_groups: any[];
}

export interface AccountSearchResult {
  items: Account[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}

interface Account {
  id: number;
  name: string;
  account_type_name: string;
  is_system_account: boolean;
  code: string;
}

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["account"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getAccountById: builder.query<any, number>({
      query: (id) => `/accounts/${id}`,
      providesTags: ["account"],
    }),

    getAllAccount: builder.query({
      query: () => `/accounts`,
      providesTags: ["account"],
    }),

    getAllAccountWithType: builder.query({
      query: () => `/accounts/with_types`,
      providesTags: ["account"],
    }),

    searchAccounts: builder.query<AccountSearchResult, AccountSearch>({
      query: (input) => ({
        url: `/accounts/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["account"],
    }),

    createAccount: builder.mutation<void, any>({
      query: (input) => ({
        url: `/accounts`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["account"],
    }),

    updateAccount: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/accounts/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["account"],
    }),

    deleteAccount: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `/accounts/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["account"],
    }),
    getprofitReport: builder.query({
      query: ({ start_date, end_date }) =>
        `/accounts/get/account-wise-purchase-report/?start_date=${start_date}&end_date=${end_date}`,
      providesTags: ["account"],
    }),
    // getprofitReport: builder.query<void,any>({
    //   query: () =>
    //     `/accounts/get/account-wise-purchase-report/`,
    //   providesTags: ["account"],
    // }),
    downloadProfitReport: builder.mutation<Blob, { start_date?: string; end_date?: string }>({
      query: (params) => ({
        url: "/accounts/account-wise-purchase-report/download",
        method: "GET",
        params,
        responseHandler: (response:Response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetAccountByIdQuery,
  useSearchAccountsQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
  useGetAllAccountQuery,
  useGetAllAccountWithTypeQuery,
  useGetprofitReportQuery,
  useDownloadProfitReportMutation
  
} = accountApi;
